(function(angular, _) {
    'use strict';
    angular.module('wtApp.wtFormatFilters')
        .filter('complexLimitTo', [function() {
            // FIXME: enable eslint and fix eslint issues
            /*eslint-disable*/
            return function(input, options) {
                if (!input) {
                    return;
                }
                var tmp = input.split(' ');
                if (tmp[0] && tmp[0].length > options.firstPartLength) {
                    tmp[0] = tmp[0].substring(0, options.firstPartLength)
                        + ' ' + tmp[0].substring(options.firstPartLength);
                    input = tmp.join(' ');
                }
                if (input.length > options.inputMaxLength) {
                    return input.substring(0, options.firstPartLength) + options.separator
                        + input.substring(input.length - 1 - options.secondPartLength);
                }
                return input;
            };
            /*eslint-enable*/
        }])
        .filter('breakEvery', [function() {
            return function(_str, _limit) {
                var str = _str;
                var limit = _limit;
                var addLineBreaks = function(_string, _lim) {
                    var string = _string;
                    var lim = _lim;
                    var result = '';
                    while (string.length > 0) {
                        result += string.substring(0, lim) + '\n';
                        string = string.substring(lim);
                    }
                    return result;
                };
                var parts = str.split(' ');
                _.forEach(parts, function(el, index) {
                    parts[index] = addLineBreaks(el, limit);
                });
                return parts.join(' ');
            };
        }])
        .filter('htmlEntities', ['$sce', function($sce) {
            return function(_str, _raw) {
                var str = _str;
                var raw = _raw;
                str = String(str).replace(/\<|\>|\"|\'|\&/g, function(matchStr) {
                    /* eslint consistent-return:0 */
                    switch (matchStr) {
                        case '<':
                            return '&lt;';
                        // break;
                        case '>':
                            return '&gt;';
                        // break;
                        case '\"':
                            return '&quot;';
                        // break;
                        case '\'':
                            return '&#39;';
                        // break;
                        case '&':
                            return '&amp;';
                        // break;
                        default:
                            break;
                    }
                });
                return raw ? str : $sce.trustAsHtml(str);
            };
        }])
        .filter('stringEscape', [function() {
            return function(_str) {
                var str = _str;
                str = String(str).replace(/\"|\'/g, function(matchStr) {
                    /* eslint consistent-return:0 */
                    switch (matchStr) {
                        case '\"':
                            return '\\\"';
                        // break;
                        case '\'':
                            return '\\\'';
                        // break;
                        default:
                            break;
                    }
                });
                return str;
            };
        }])

        /**
         * filters a list of objects for a given attribute and value
         * if the attribute is of type boolean,
         * true matches 'yes', '1', 'true'
         * false matches 'no', '0', 'false'
         */
        .filter('searchBoolean', [function() {
            var booleanMatcher = {
                trueMatcher: ['yes', 'Yes', 'true', '1'],
                falseMatcher: ['no', 'No', 'false', '0']
            };
            return function(items, key, _word, options) {
                var word = _word;
                var compositeKeys = [key];
                var totalMatches = [];
                if (word === '') {
                    return items;
                }
                if (options) {
                    if (options.trueMatcher) {
                        booleanMatcher.trueMatcher = _.union(booleanMatcher.trueMatcher, options.trueMatcher);
                    }
                    if (options.falseMatcher) {
                        booleanMatcher.falseMatcher = _.union(booleanMatcher.falseMatcher, options.falseMatcher);
                    }
                    if (options.compositeKeys && options.compositeKeys[key]) {
                        compositeKeys = options.compositeKeys[key];
                    }
                }
                angular.forEach(items, function(item) {
                    delete item.$$hashKey;
                    if (options && options.compositeKeys && options.compositeKeys[key]) {
                        compositeKeys = options.compositeKeys[key];
                        item[key] = '';
                        angular.forEach(compositeKeys, function(cKey) {
                            item[key] += item[cKey] + ' ';
                        });
                    }
                    if (_.isString(item[key])) {
                        word = word.toLowerCase();
                        var matches = item[key].toLowerCase().indexOf(word);
                        if (matches >= 0) {
                            totalMatches.push(item);
                        }
                    } else if (_.isBoolean(item[key])) {
                        if (item[key] === true && _.includes(booleanMatcher.trueMatcher, word)) {
                            totalMatches.push(item);
                        } else if (item[key] === false && _.includes(booleanMatcher.falseMatcher, word)) {
                            totalMatches.push(item);
                        }
                    } else if (key === '$') {
                        var someKey;
                        for (someKey in item) {
                            if (item[someKey] === true && _.includes(booleanMatcher.trueMatcher, word)) {
                                totalMatches.push(item);
                                break;
                            } else if (item[someKey] === false && _.includes(booleanMatcher.falseMatcher, word)) {
                                totalMatches.push(item);
                                break;
                            } else if (_.isString(item[someKey]) && item[someKey]
                                    .toLowerCase().match(word.toLowerCase())) {
                                totalMatches.push(item);
                                break;
                            }
                        }
                    }
                });
                return totalMatches;
            };
        }])
        .filter('orderReportFilter', [function() {
            return function(items) {
                var filtered = [];
                angular.forEach(items, function(item) {
                    filtered.push(item);
                });
                filtered.sort(function(elemA, elemB) {
                    return (elemA.title.toLowerCase() > elemB.title.toLowerCase() ? 1 : -1);
                });
                return filtered;
            };
        }])

        /**
         * Should help replace deprecated ng-bind-html-unsafe directive: Simply renders html code as safe.
         */
        .filter('unsafe', ['$sce', function($sce) {
            return $sce.trustAsHtml;
        }])

        /**
         * Should remove iframe tags from a string whose src does not contain the proper keywords given an array of strings.
         * Plus add a wmode query parameter
         */
        .filter('strictFrame', [function() {
            return function(input, srcList) {
                var processedInput;
                if (!_.isString(input) || !_.isArray(srcList) || _.isEmpty(srcList)) {
                    return input;
                }
                var addWmode = function(str) {
                    var parts;
                    var queryPart;
                    if (!_.isString(str) || !str) {
                        return str;
                    }
                    parts = str.split('?');

                    if (parts.length === 1) {
                        return str + '?wmode=opaque';
                    }

                    queryPart = _.last(parts);

                    queryPart = _.chain(queryPart).split('&').map(function(e) {
                        return e.split('=');
                    }).fromPairs().value();
                    queryPart.wmode = 'opaque';
                    queryPart = _.chain(queryPart).map(function(value, key) {
                        return key + '=' + value;
                    }).join('&').value();
                    parts[parts.length - 1] = queryPart;
                    return parts.join('?');
                };
                processedInput = input.replace(/(<iframe.*?>.*?<\/iframe>)/g, function(foundTag) {
                    var regexp = new RegExp('src=".+' + srcList.join('|'), 'gi');
                    return regexp.test(foundTag) ? foundTag : '';
                });
                processedInput = processedInput.replace(/src="(.*?)"/, function(foundSrc) {
                    return 'src="' + addWmode(foundSrc.replace('src="', '').replace('"', '')) + '"';
                });
                return processedInput;
            };
        }])

        /**
         * Will return the text of a mapping list key of a metric or dimension
         * @param  {String|Number}  key     The index to look for in the mapping hash
         * @param  {{}}             mapping Key value hash
         * @return {String}         The found text or the key if not found
         */
        .filter('arrangeTypeMapping', [function() {
            return function(key, mapping) {
                return _.find(mapping, function(e, k) {
                    return String(k) === String(key);
                }) || key;
            };
        }])

        /**
         * Given a collection will determine the length of its keys array, hence size
         */
        .filter('collectionSize', [function() {
            return function(collection) {
                return collection && Object.keys(collection).length;
            };
        }])

        /**
         * Given a key pair collection, returns a list of objects with key and value properties
         */
        .filter('keyValueArray', [function() {
            return function(collection) {
                return _.map(collection, function(value, key) {
                    return {
                        key: key,
                        value: value
                    };
                });
            };
        }]);
})(window.angular, window._);
